import MainRouter from 'components/router/MainRouter';
import 'assets/css/color.css';
import 'assets/css/global.css';
import 'assets/css/antCustomizations.css';
import 'assets/css/leafletCustomizations.css';

function App() {
  return (
    <div className='App'>
      <MainRouter />
    </div>
  );
}

export default App;
